import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";
import { get as lodashGet } from "lodash-es";

export const usePersonalizedHomepage = () => {
  const { data: config } = useInstanceConfigQuery();

  return {
    isPersonalisedHomepageVisible: lodashGet(
      config,
      "custom_ui_labels.specialFeatures",
      [""]
    ).includes("PERSONALISED_HOMEPAGE")
  };
};
